/*
 * Carbisdale - Spellcheck-Refresh nach Remote-Sync
 *
 * Wird vom `onRemoteChanges`-Handler aufgerufen, nachdem `setParagraphsRT`
 * den frischen Server-Stand ins Modell gespielt hat. `setParagraphsRT`
 * triggert KEINE `_markParagraphDirty`-Events — die `addParagraphDirtyListener`-
 * Bruecke zum SpellCheckManager (die beim normalen Tippen die Welle aktuell
 * haelt) bleibt also still. Ohne diesen expliziten Refresh waeren die
 * Spellcheck-Warnungen fuer remote-eingespielte Aenderungen stale, bis der
 * User selbst tippt.
 *
 * Zwei Schritte:
 *   1. Falls Paragraphen geloescht wurden: Cache-Eintraege fuer nicht mehr
 *      existente IDs aus dem Manager droppen (Memory-Leak-Schutz).
 *   2. Fuer jeden geaenderten Paragraph alle drei Felder (text/note/info)
 *      sofort neu pruefen lassen — `checkNowAllFields` skippt leere Felder
 *      und Code-Blocks ohne Worker-Roundtrip.
 *
 * @param {object|null} spellCheckManager - kann null sein (Spellcheck noch nicht
 *   bootstrapped) — dann no-op.
 * @param {Array<{id: string}>} paragraphsAfterSync - aktuelle Paragraph-Liste
 *   im Modell NACH dem `setParagraphsRT`-Aufruf.
 * @param {Array<{id?: string}>} changes - vom Server angewandte Aenderungen.
 * @param {number} deletedCount - Anzahl lokal geloeschter Paragraphen
 *   (wegen `serverParagraphOrder`-Drift).
 */
export function refreshSpellCheckAfterRemoteSync(
    spellCheckManager, paragraphsAfterSync, changes, deletedCount
) {
    if (!spellCheckManager) return
    if (deletedCount > 0) {
        const knownIds = new Set()
        for (const p of paragraphsAfterSync) {
            if (p && p.id != null) knownIds.add(p.id)
        }
        spellCheckManager.purgeUnknownParagraphs(knownIds)
    }
    if (!changes) return
    for (const c of changes) {
        if (c && c.id) spellCheckManager.checkNowAllFields(c.id)
    }
}
